import { setupValidation } from './validation.js';
import { initNavigation, setupNextButtons, setupBackButtons, showInitialStep } from './navigation.js';
import { trackOnboardingCompleted } from '../analytics/onboarding.js';

/**
 * Handle "Get Started" button to show survey form
 */
export function getStartedSurveyForm() {
	const getStartedOnboarding = document.getElementById('get-started-onboarding');
	if (!getStartedOnboarding) return;

	const getStartedBtn = document.querySelector('#get-started-onboarding button');
	if (!getStartedBtn) return;

	const onboardingForm = document.getElementById('onboarding-form');
	if (!onboardingForm) return;

	getStartedBtn.addEventListener('click', () => {
		onboardingForm.classList.remove('hidden');
		getStartedOnboarding.classList.add('hidden');
	});
}

/**
 * Initialize survey form with navigation and validation
 */
export function initSurveyForm() {
	const steps = document.querySelectorAll('.form-step');
	const nextBtns = document.querySelectorAll('.next-btn');
	const backBtns = document.querySelectorAll('.back-btn');
	const stepSegments = document.querySelectorAll('.step-segment');
	const currentStepText = document.getElementById('currentStep');

	if (!steps.length) return;

	// Initialize navigation with DOM references
	initNavigation({ steps, stepSegments, currentStepText });

	// Setup button handlers
	setupNextButtons(nextBtns);
	setupBackButtons(backBtns);

	// Initialize validation
	setupValidation(steps);

	// Show first step
	showInitialStep();
}

export function onFormSubmitted() {
	const onboardingForm = document.getElementById('onboarding-form');
	if (!onboardingForm) return;
	const form = onboardingForm.querySelector('form');
	const submitButton = onboardingForm.querySelector('button[type="submit"]');
	if (!submitButton || !form) return;

	let isSubmitting = false;

	submitButton.addEventListener('click', (e) => {
		e.preventDefault();

		if (isSubmitting) return;
		isSubmitting = true;

		// Track form submission with field values
		const formData = new FormData(form);
		trackOnboardingCompleted({
			weight: formData.get('weight') || '',
			height: formData.get('height') || '',
			weight_goal: formData.get('weight_goal') || '',
			bone_mass: formData.get('bone_mass') || '',
		});

		submitButton.disabled = true;
		submitButton.style.opacity = '0.6';
		submitButton.style.cursor = 'not-allowed';

		form.submit();
	});
}
